import Icon from './Icon';
import { ALL_IN_ONE } from '../constants/content';
import { SUPPORT_PHONE_LABEL, SUPPORT_PHONE_TEL } from '../constants/site';
import { openZohoChat } from '../utils/openZohoChat';

export default function AllInOne() {
  return (
    <section className="section section--soft allinone" id="services">
      <div className="shell allinone__inner allinone__inner--flip">
        <figure className="allinone__visual">
          <img
            src="/images/allinone-devices.webp"
            alt="Desktop and laptop showing an accounting dashboard with charts and reports"
            width="1100"
            height="825"
            loading="lazy"
            decoding="async"
          />
        </figure>

        <div className="allinone__copy">
          <p className="kicker kicker--left">More than software fixes</p>
          <h2>Full bookkeeping support for growing businesses</h2>

          {ALL_IN_ONE.map((group) => (
            <div className="allinone__group" key={group.heading}>
              <h3>{group.heading}</h3>
              <ul>
                {group.items.map((item) => (
                  <li key={item}>
                    <Icon name="check" size={15} />
                    {item}
                  </li>
                ))}
              </ul>
            </div>
          ))}

          <div className="allinone__actions">
            <a href={SUPPORT_PHONE_TEL} className="btn btn--green">
              <Icon name="phone" size={18} />
              Call {SUPPORT_PHONE_LABEL}
            </a>
            <button type="button" className="btn btn--green-line" onClick={openZohoChat}>
              <Icon name="chat" size={18} />
              Live Chat
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
